import React from 'react';
import { isEmpty } from 'lodash';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { Field } from 'formik';
import { toast } from 'react-toastify';
import { isMobileOnly } from 'react-device-detect';

import BgvSecureText from '../../../CommonComponent/BgvSecureText/BgvSecureText';
import ValidatedFormInputField from '../../../../../core-components/ValidatedFormInputField';
import ProgressBar from '../../../../../core-components/ProgressBar';
import { getErrorMessage, getTrimmedValue } from '../../../../../utils/utilities';
import { checkBgvCandidateEmployeeId as checkBgvCandidateEmployeeIdAPI } from '../../../../../api/bgv';

import styles from './BasicDetails.module.scss';
import ValidatedRadioFields from '../../../../../core-components/ValidatedRadioFields';
import { sexTypes } from '../../../../../utils/commonConstant';

class BasicDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEmpIdValid: true
    };
  }

  handleChange = (e) => {
    const { setFieldValue, handleChange } = this.props;

    handleChange(e);
    if (e?.target?.value && e?.target?.value?.length >= 2) {
      this.setState({ isEmpIdValid: false });
      checkBgvCandidateEmployeeIdAPI(e.target.value)
        .then((response) => {
          if (response?.data?.data?.resp) {
            setFieldValue('employeeIdExists', true);
            this.setState({ isEmpIdValid: false });
          } else {
            this.setState({ isEmpIdValid: true });
            setFieldValue('employeeIdExists', false);
          }
        })
        .catch((error) => toast.error(getErrorMessage(error)));
    }
  };

  componentDidMount() {
    window.scroll(0, 0);
  }

  onChangeSex = (e) => {
    this.props.setFieldValue('gender', e.target.value);
  }
  render() {
    const { isSubmitting, values, errors, handleSubmit, initial_candidate_details, setFieldValue } =
      this.props;
    const enableBtn =
      !isSubmitting && isEmpty(errors) && this?.state?.isEmpIdValid && !values?.employeeIdExists
        ? true
        : false;
    const indexing =
      this?.props?.totalSteps
        .map((val) => {
          return val?.id;
        })
        .indexOf(-1) + 1;
    const setValue = (fieldname, value, withSpace) => {
      setFieldValue(fieldname, getTrimmedValue(value, withSpace));
    };
    return (
      <Card className={styles.basicDetailsCard}>
        <Card.Body className={styles.basicDetailsCardBody}>
          {!isMobileOnly ? (
            <div data-testid='no-mobile-header'>
              <span className={styles.basicDetailHeading}>Basic Details</span>
              <div className={styles.basicDetailProgressContainer}>
                <span className={styles.stepText}>
                  {indexing} of {this.props.totalSteps.length}
                </span>
                <ProgressBar max={this.props.totalSteps.length} min={0} now={indexing} />
              </div>
            </div>
          ) : (
            <>
              <BgvSecureText />
              <div className={styles.basicDetailProgressContainerMobile}>
                <span className={styles.basicDetailHeading}>Basic Details</span>
                <span className={styles.stepTextMobile}>
                  {indexing} of {this.props.totalSteps.length}
                </span>
              </div>
              <ProgressBar max={this.props.totalSteps.length} min={0} now={indexing} />
            </>
          )}

          <Form
            onSubmit={handleSubmit}
            className='basic-details-form'
            data-testid='basic-details-form'
          >
            <Row>
              <Col sm={12} xs={12} md={8} lg={8}>
                <Form.Label>
                  Full Name<span>*</span>
                </Form.Label>
                <Field
                  data-testid='full-name'
                  type='text'
                  name='full_name'
                  className={'fullName'}
                  component={ValidatedFormInputField}
                  autoFocus
                  onBlur={(e) => {
                    this.props?.handleBlur(e);
                    setValue('full_name', values?.full_name, true);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12} md={12} lg={12}>
                <Form.Label>Sex {!values?.is_sex_optional ? <span>*</span> : null}</Form.Label>
                <Field
                  name='gender'
                  component={ValidatedRadioFields}
                  options={sexTypes}
                  className={styles.sex}
                  onChange={(e) => {
                    this.onChangeSex(e);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12} md={6} lg={6}>
                <Form.Label>Employee ID</Form.Label>
                <Field
                  data-testid='employee-id'
                  type='text'
                  name='employee_id'
                  component={ValidatedFormInputField}
                  className={values.employeeIdExists ? styles.emailError : null}
                  onChange={this.handleChange}
                  disabled={true}
                />
                {!errors.employee_id && values.employeeIdExists && (
                  <div className={styles.emailErrorMsg}>
                    {values.employeeIdExists ? 'Employee ID already exists' : ''}
                  </div>
                )}
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12} md={6} lg={6}>
                <Form.Label>Universal Account Number (UAN)</Form.Label>
                <Field
                  data-testid='uan-number'
                  type='text'
                  name='uan_number'
                  className={'UAN'}
                  component={ValidatedFormInputField}
                  // autoFocus
                  onBlur={(e) => {
                    this.props?.handleBlur(e);
                    setValue('uan_number', values?.uan_number, false);
                  }}
                />
              </Col>
            </Row>
            <Row className={styles.basicDetailSubmitBtn}>
              <Col sm={12} xs={12} md={12} lg={12}>
                <Button
                  data-testid='next-btn'
                  type='submit'
                  className={
                    !enableBtn || this.props.isLoadingBgvCache || this.props.internalLoading
                      ? styles.disabledBtn
                      : styles.activeBtn
                  }
                  disabled={
                    !enableBtn || this.props.isLoadingBgvCache || this.props.internalLoading
                  }
                >
                  Next
                </Button>
              </Col>
            </Row>
          </Form>
          <p className={styles.basicDetailInfo}>All fields marked with an asterisk are required</p>
        </Card.Body>
      </Card>
    );
  }
}

export default BasicDetails;
